import { 
  LectureInfoListResponse, 
  ApiPaginatedResponse, 
  ApiLectureItem,
  LectureFaqResponse
} from '../types';
import { apiClient } from '.';

// 카테고리별 강의 정보 목록 가져오기 (페이지네이션 지원)
export const fetchLecturesByCategory = async (categoryRouteName: string, page: number = 0, size: number = 50): Promise<LectureInfoListResponse> => {
  const url = `/api/lectures/info/list/filtered?categoryRouteName=${categoryRouteName}&page=${page}&size=${size}`;
  
  try {
    console.log('요청:', url);
    
    const { data } = await apiClient.get<ApiPaginatedResponse>(url);
    console.log('응답 object:', data);
    
    // API 응답 구조를 변환
    const transformedData = {
      code: data.code,
      status: data.status,
      message: data.message,
      data: data.data.content.map((item: ApiLectureItem) => ({
        id: item.lecture_info.id,
        title: item.lecture_info.title,
        caption: item.lecture_info.caption,
        thumbnail_url: item.lecture_info.thumbnail_url,
        name: item.lecture_info.name,
        tags: item.lecture_info.tags,
        introduction: item.lecture_info.introduction,
        lecturer_name: item.lecturer_info.name,
        lecturer_introduction: item.lecturer_info.introduction
      })),
      pagination: {
        totalPages: data.data.totalPages,
        totalElements: data.data.totalElements,
        pageNumber: data.data.pageable.pageNumber,
        pageSize: data.data.pageable.pageSize
      }
    };
    
    return transformedData;
  } catch (error) {
    console.error('카테고리별 강의 정보 목록 가져오기 실패:', error);
    throw error;
  }
};

// 전체 강의 정보 목록 가져오기 (전체보기용 - 파라미터 없음)
export const fetchAllLectures = async (page: number = 0, size: number = 50): Promise<LectureInfoListResponse> => {
  const url = `/api/lectures/info/list/filtered?page=${page}&size=${size}`;
  
  try {
    console.log('요청:', url);
    
    const { data } = await apiClient.get<ApiPaginatedResponse>(url);
    console.log('응답 object:', data);
    
    // API 응답 구조를 변환
    const transformedData = {
      code: data.code,
      status: data.status,
      message: data.message,
      data: data.data.content.map((item: ApiLectureItem) => ({
        id: item.lecture_info.id,
        title: item.lecture_info.title,
        caption: item.lecture_info.caption,
        thumbnail_url: item.lecture_info.thumbnail_url,
        name: item.lecture_info.name,
        tags: item.lecture_info.tags,
        introduction: item.lecture_info.introduction,
        lecturer_name: item.lecturer_info.name,
        lecturer_introduction: item.lecturer_info.introduction
      })),
      pagination: {
        totalPages: data.data.totalPages,
        totalElements: data.data.totalElements,
        pageNumber: data.data.pageable.pageNumber,
        pageSize: data.data.pageable.pageSize
      }
    };
    
    return transformedData;
  } catch (error) {
    console.error('전체 강의 정보 목록 가져오기 실패:', error);
    throw error;
  }
};

// 강의 FAQ 목록 가져오기 (페이지네이션 지원)
export const fetchClassFAQ = async (lectureId: number, page: number = 0, size: number = 4): Promise<LectureFaqResponse> => {
  const url = `/api/lecture-faqs/filtered/${lectureId}?page=${page}&size=${size}`;
  
  try {
    const { data } = await apiClient.get<LectureFaqResponse>(url);
    console.log('FAQ 응답:', data);
    return data;
  } catch (error) {
    console.error('강의 FAQ 목록 가져오기 실패:', error);
    throw error;
  }
};
